import React from 'react';
import { Box, Skeleton } from '@mui/material';

interface PageSkeletonProps {
  /** 위에서부터 각 블록의 높이(px) — 페이지 레이아웃 비슷하게 */
  blocks?: number[];
}

/**
 * 첫 진입(캐시 없음) 시 풀스크린 로딩 대신 보여줄 페이지 골격.
 * 화면을 먼저 그리고 데이터는 백그라운드에서 채운다는 원칙의 마지막 조각.
 */
const PageSkeleton: React.FC<PageSkeletonProps> = ({ blocks = [56, 320, 400] }) => (
  <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
    <Skeleton variant="text" width={240} height={40} />
    {blocks.map((height, i) => (
      <Skeleton
        key={i}
        variant="rounded"
        height={height}
        sx={{ borderRadius: 'var(--r-16)' }}
      />
    ))}
  </Box>
);

export default PageSkeleton;
